import pearClient from 'apis/pearClient';
import CircularLoader from 'components/common/CircularLoader';
import React, { useEffect, useState } from 'react';
import ReactMarkdown from 'react-markdown';
import { useLocation } from 'react-router-dom';
import { config } from 'utils/config';
import { iframePostMessage } from 'utils/constants';
import { sessionGet, SessionKeys } from 'utils/tokenStorage';

const LessonContent = () => {
  const [contents, setContents] = useState<string[]>([]);

  const useQuery = () => {
    const { search } = useLocation();
    return React.useMemo(() => new URLSearchParams(search), [search]);
  };
  const documentLocale = useQuery().get('locale') || 'en';

  const fetchFullModuleContent = async (locale: string) => {
    const response = await pearClient.assets.fetchFullModuleContent(locale);
    setContents(` ${response}`.split(/[^#.]#\s/));
  };

  const imageComponent = (props: any): JSX.Element => {
    const module = props.src.replace(/(-\d+)?\..*$/, '');
    return (
      <img
        alt={props.alt}
        src={`${config.HYLIA_ASSETS_URL}/clinical-content/${documentLocale}/${module}/images/${props.src}`}
      />
    );
  };

  const linkComponent = (props: any): JSX.Element => {
    const [filename, ext] = props.href.split('.');

    if (ext === 'mp4') {
      let moduleName = filename;
      if (/^\d+$/.test(filename[filename.length - 1])) {
        moduleName = filename.substring(0, filename.lastIndexOf('-'));
      }
      return (
        <a
          href={`${config.HYLIA_ASSETS_URL}/clinical-content/${documentLocale}/${moduleName}/videos/${props.href}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          <i>{`[Watch video ${props.href}]`}</i>
        </a>
      );
    }
    if (ext === 'pdf') {
      return (
        <a
          href={`${config.HYLIA_ASSETS_URL}/clinical-content/${documentLocale}/${filename}/worksheets/${props.href}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          <i>{`[Download worksheet ${props.href}]`}</i>
        </a>
      );
    }
    return (
      <p>
        <i>[Embedded Link]</i>
      </p>
    );
  };

  useEffect(() => {
    if (contents.length === 0) {
      fetchFullModuleContent(documentLocale);
    }

    setTimeout(() => {
      const iframeHeight = window.document.body.clientHeight;

      if (window && window.parent) {
        window.parent.postMessage(
          {
            payload: {
              action: iframePostMessage.UPDATE_CONTENT_HEIGHT,
              contentHeight: iframeHeight,
            },
          },
          sessionGet(SessionKeys.ORIGIN)!,
        );
      }
    }, 1000);
  }, [contents, documentLocale]);

  const renderers = {
    img: imageComponent,
    a: linkComponent,
  };

  return contents.length !== 0 ? (
    <div data-testid="documents-lesson-content">
      {contents.map((value: string) => {
        if (value === '') return null;
        return (
          <ReactMarkdown key={value} components={renderers}>
            {`# ${value}`}
          </ReactMarkdown>
        );
      })}
    </div>
  ) : (
    <CircularLoader />
  );
};

export default LessonContent;
